import { render } from "./MemoForm.vue?vue&type=template&id=5dc8289f&scoped=true"
import script from "./MemoForm.vue?vue&type=script&lang=js"
export * from "./MemoForm.vue?vue&type=script&lang=js"

import "./MemoForm.vue?vue&type=style&index=0&id=5dc8289f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc8289f"]])

export default __exports__